import './Filter.scss';
import React, { useState } from 'react';
import FilterItem from './FilterItem';
import Button from 'react-bootstrap/Button';
import { Error, Loading } from '../_common';
import { Query } from '../_common';
import { GET_JOB_FILTERS_LIST } from '../../graphql/client/queries';
import {
    GetJobFiltersList_getJobFiltersList_customers as CustomerFilter,
    GetJobFiltersList_getJobFiltersList_regions as RegionFilter,
    GetJobFiltersList_getJobFiltersList_districts as DistrictsFilter,
    GetJobFiltersList_getJobFiltersList_statuses as StatusFilter,
} from '../../types/schemaTypes';
import { GetJobFiltersList } from '../../types/schemaTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface JobFiltersProps {
    abortRequest: () => void;
    onFilterToggle: () => void;
    showFilter: boolean;
    setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

export const JobFilters = ({
    abortRequest,
    onFilterToggle,
    showFilter,
    setShowFilter,
}: JobFiltersProps): React.ReactElement => {
    const [activeKey, setActiveKey] = useState('0');
    let statusFilters: StatusFilter[] = [];
    let districtFilters: DistrictsFilter[] = [];
    let regionFilters: RegionFilter[] = [];
    let customerFilters: CustomerFilter[] = [];

    const onSelectAll = (): void => {
        setActiveKey(activeKey === '0' ? '1' : '0');
    };

    return (
        <Query<GetJobFiltersList> query={GET_JOB_FILTERS_LIST}>
            {({ loading, error, data }): React.ReactElement  => {
                if (loading) {
                    return (
                        <div className="Filter-Loading">
                            <Loading />
                        </div>
                    );
                }
                if (error) {
                    return <Error error={error} />;
                }

                if (data?.getJobFiltersList) {
                    const list = data.getJobFiltersList;
                    statusFilters = (list.statuses ?? []).filter(stat => stat?.name !== 'Unknown') as StatusFilter[];
                    districtFilters = (list.districts ?? []) as DistrictsFilter[];
                    regionFilters = (list.regions ?? []) as RegionFilter[];
                    customerFilters = (list.customers ?? []) as CustomerFilter[];
                }

                return (
                    <div
                        id="MessagesFilterContainer"
                        className={
                            showFilter
                                ? 'JobLoads-FiltersContainer Job-FiltersContainer'
                                : 'JobLoads-FiltersContainer Job-FiltersContainer hide'
                        }
                    >
                        <div className="Filter-Container">
                            <div className="Filter-Header">
                                <div className="Filter-HeaderIconContainer">
                                    <i className="material-icons">filter_list</i>
                                    <span className="Filter-HeaderTitle">Filters</span>
                                </div>
                                <Button className="Filter-SelectAll" variant="link" onClick={onSelectAll}>
                                    {activeKey === '0' ? 'Collapse All' : 'Expand All'}
                                </Button>
                                <FontAwesomeIcon
                                    icon={['fas', 'times-circle']}
                                    className="JobLoads-Filter"
                                    onClick={() => setShowFilter(!showFilter)}
                                />
                            </div>

                            <div className="Filter-Body">
                                <FilterItem
                                    abortRequest={abortRequest}
                                    title="Status"
                                    items={statusFilters}
                                    activeKey={activeKey}
                                    isCollection={true}
                                    isSearchable={false}
                                    onFilterToggle={onFilterToggle}
                                />
                                <FilterItem
                                    abortRequest={abortRequest}
                                    title="Regions"
                                    items={regionFilters}
                                    activeKey={activeKey}
                                    isCollection={true}
                                    isSearchable
                                    onFilterToggle={onFilterToggle}
                                />
                                <FilterItem
                                    abortRequest={abortRequest}
                                    title="Districts"
                                    items={districtFilters}
                                    activeKey={activeKey}
                                    isCollection={false}
                                    isSearchable
                                    onFilterToggle={onFilterToggle}
                                />
                                <FilterItem
                                    abortRequest={abortRequest}
                                    title="Customers"
                                    items={customerFilters}
                                    activeKey={activeKey}
                                    isCollection={false}
                                    isSearchable
                                    onFilterToggle={onFilterToggle}
                                />
                            </div>
                        </div>
                    </div>
                );
            }}
        </Query>
    );
};
